import React from 'react';
import { logEventOnComponentRendered } from '../utils/AnalyticsUtil';

const BaseComponent = ({ name, children }) => {
  logEventOnComponentRendered(name);
  return <React.Fragment>{children}</React.Fragment>;
};

export default BaseComponent;
